import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
  amend_unit_measurement_status: { status: "idle" },
};

export const amend_unit_measurement_status_Slice = createSlice({
  name: "amend_unit_measurement_status",
  initialState,
  reducers: {
    success_amend_unit_measurement_status: (state, action) => {
      state.amend_unit_measurement_status = { status: app_consts.SUCCESS, data: action.payload };
    },
    fail_amend_unit_measurement_status: (state, action) => {
      state.amend_unit_measurement_status = { status: app_consts.FAIL, message: action.payload };
    },
    reset_amend_unit_measurement_status: (state) => {
      state.amend_unit_measurement_status = { status: app_consts.IDLE };
    },
    loading_amend_unit_measurement_status: (state) => {
      state.amend_unit_measurement_status = { status: app_consts.LOADING };
    },
  },
});

export const {
  success_amend_unit_measurement_status,
  fail_amend_unit_measurement_status,
  reset_amend_unit_measurement_status,
  loading_amend_unit_measurement_status,
} = amend_unit_measurement_status_Slice.actions;

export default amend_unit_measurement_status_Slice.reducer;
